import $ from 'jquery';

import Error from './error';
import Confirmer from './confirm';

import ApplicationFormBase from './application-form-base';

export default class CreateForm {
	
	constructor() {


		if ($("#create_form").length > 0) {
			try {
				this.init(window.formData);
			} catch(ex) {
				// form not found...
			}

		}
		
	}

	init(data) {

        let dataObject = {
            form: data
        };

        Vue.component('create-form', () => import('../components/CreateForm.vue'));

        this.vm = new Vue({
            template: '<create-form :form="form"></create-form>',
            el: "#create_form",
            data: dataObject,
            methods: {

            }
        });

        $("#form-save").click(e => {

            $.ajax({
                data:{
                    op: "saveCreateForm",
                    data: JSON.stringify(dataObject.form),
                    id: window.formDataId
                }
            });

        })

	}


}
